import { useState, useEffect, Dispatch, SetStateAction } from 'react';
import { ItineraryItem } from '../types/Quotation';

export function useItinerary(nights: number): [ItineraryItem[], Dispatch<SetStateAction<ItineraryItem[]>>] {
  const [itinerary, setItinerary] = useState<ItineraryItem[]>([]);

  useEffect(() => {
    const items: ItineraryItem[] = [];
    for (let i = 1; i <= nights + 1; i++) {
      items.push({
        day: i,
        title: '',
        place: { label: '', value: '', nights: 1 },
        flights: [],
        activities: [],
        hotels: [],
        transfers: []
      });
    }
    setItinerary(items);
  }, [nights]);

  return [itinerary, setItinerary];
}
